// AUTO-GENERATED — do not edit manually. Run `npm run set-env` to regenerate.
export const environment = {
  "apiUrl": "https://development.casando.fullstackagency.it/api/v1",
  "applicationId": "d8e3f721-9b52-4c89-a936-1e4d7f8a9c05",
  "redirectUrl": "https://development.casando.fullstackagency.it/callback",
  "meilisearch": "https://CI_COMMIT_BRANCH.meilisearch.fullstackagency.it",
  "meilisearchKey": "aaaa"
};
